export class GoogleMapMark {
  constructor(
    public position: google.maps.LatLngLiteral,
    public options: GoogleMapMarkOptions = new GoogleMapMarkOptions(),
    public markerOptions: google.maps.MarkerOptions = null
  ) {
  }
}

export class GoogleMapMarkOptions {
  constructor(
    public title: string = null,
    public number: string = null,
    public address: string = null,
    public link: string = null,
    public locationId: string = null,
    public mapMarker: any = null
  ) {
  }
}
